import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { NOTIFICATION_STYLE_LIST } from 'src/constants/queryKeys';

import useFormsModalStore from 'src/store/forms';
import { networkRemoveNotificationStyle, useFetchNotificationStyleList } from 'src/network/notification-style-list';

export const useNotificationStyleList = ({ selected, setSelected, selectPopupFrame }) => {
  const queryClient = useQueryClient();

  const { enqueueSnackbar } = useSnackbar();

  const { setModal } = useFormsModalStore();

  const [tableData, setTableData] = useState([]);

  const [deleteLoading, setDeleteLoading] = useState(false);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);

  const handleDeleteRow = (notificationStyleId) => {
    setDeleteLoading(true);
    networkRemoveNotificationStyle(notificationStyleId)
      .then(() => {
        const newTableData = tableData.filter((row) => row.NotificationStyleID !== notificationStyleId);
        setTableData(newTableData);
        enqueueSnackbar('فریم موردنظر با موفقیت حذف شد');

        const newSelectedItems = selected?.filter((id) => id !== notificationStyleId);
        setSelected(newSelectedItems);

        queryClient.invalidateQueries({ queryKey: [NOTIFICATION_STYLE_LIST] });
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setOpenConfirmDelete(false);
        setDeleteLoading(false);
      });
  };

  const handleDeleteRows = async (notificationStyleIDs) => {
    try {
      setDeleteLoading(true);

      const deletePromises = notificationStyleIDs.map((id) => networkRemoveNotificationStyle(id));

      await Promise.all(deletePromises);

      const newTableData = tableData.filter((row) => !notificationStyleIDs.includes(row.NotificationStyleID)); // todo new
      setTableData(newTableData);

      enqueueSnackbar('فریم های موردنظر با موفقیت حذف شدند');

      await queryClient.invalidateQueries({ queryKey: [NOTIFICATION_STYLE_LIST] });

      setSelected([]);
    } catch (error) {
      console.log(error);
    } finally {
      setOpenConfirmDelete(false);
      setDeleteLoading(false);
    }
  };

  const handleEditRow = (popupStyle) =>
    setModal({ isOpen: true, data: popupStyle, type: NOTIFICATION_STYLE_LIST, title: 'ویرایش فریم اعلان' });

  const { isLoading, isFetching, data } = useFetchNotificationStyleList();

  useEffect(() => {
    if (data) {
      const result = data?.data?.items || [];

      if (selectPopupFrame) {
        const DEFAULT_DATA = {
          NotificationStyleID: -1,
          NotificationStyleImageUrl: '',
          NotificationStyleLable: 'بدون فریم',
          NotificationStyleType: -1,
          RowNum: 0,
        };

        setTableData([DEFAULT_DATA, ...result]);
      } else {
        setTableData([...result]);
      }
    }
  }, [data]);

  return {
    tableData,
    isLoading: isLoading || isFetching,
    isFetching,
    deleteLoading,
    handleDeleteRow,
    handleDeleteRows,
    handleEditRow,
    openConfirmDelete,
    setOpenConfirmDelete,
  };
};
